/**
 * @param {*} value
 * @returns {value is number}
 */
export function isNumber(value) {
  return typeof value === 'number';
}
